import { useNavigate } from "react-router";
import Layout from "../../../Components/Layout/Layout.module.css";
import counsel from "../../../Images/counsel.svg";
import objectives from "../../../Images/objectives.svg";
import performance from "../../../Images/performance.svg";
import period from "../../../Images/period.svg";
import pip from "../../../Images/pip.svg";
import rating from "../../../Images/rating.svg";
import reslt from "../../../Images/reslt.svg";
import score from "../../../Images/score.svg";
import committee from "../../../Images/committee.png";
import { useEffect, useState } from "react";
import { DEFINED_PERMISSIONS } from "../../../../../utils/const";

const CardComp = ({ title, subtitle, link, icon }) => {
  const navigate = useNavigate();
  return (
    <div className="px-4 py-8 border-[#DBD7D7] border-[2px] w-[300px] rounded-md flex">
      <div className="flex flex-col justify-between gap-5">
        <div className="">
          <img
            src={icon || "/placeholder.svg"}
            alt={`${title} icon`}
            className="text-xl text-[#305F32] max-w-8 max-h-8"
          />
        </div>
        <div className="flex flex-col gap-2 flex-1">
          <div className="text-[16px] font-bold text-[#305F32]">{title}</div>
          <div className="text-[12px] text-black">{subtitle}</div>
        </div>
        <div className="border-[#305F32] cursor-pointer border-[2px] mt-auto rounded-md w-fit bg-white hover:opacity-50">
          <div
            onClick={() => navigate(link)}
            className="px-7 py-1 text-[12px] bg-white flex justify-start"
          >
            Create
          </div>
        </div>
      </div>
    </div>
  );
};

export const HRAppraisalSetup = () => {
  const [hasAllPermissions, setHasAllPermissions] = useState(false);
  const [isHODOnly, setIsHODOnly] = useState(false);
  const [soaPerm, setSoaPerm] = useState(false);

  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm")) || [];
    const allHrPermissions = [
      DEFINED_PERMISSIONS.SeniorHRManager,
      DEFINED_PERMISSIONS.PrimaryHRManager,
      DEFINED_PERMISSIONS.HRManager, 
    ];

    const hasHODPermission = userPerm.includes(DEFINED_PERMISSIONS.HOD);
    const hasHRPermissions = userPerm.some((perm) =>
      allHrPermissions.includes(perm)
    );
    const hasAllPerms =
      (hasHODPermission && hasHRPermissions) ||
      userPerm.filter((perm) => allHrPermissions.includes(perm)).length > 1 ||
      userPerm.includes(DEFINED_PERMISSIONS.SeniorHRManager);
    const isOnlyHOD = hasHODPermission && !hasHRPermissions;
    const definedSoaPerm = DEFINED_PERMISSIONS.SeniorAppraisalOfficer;
    const hasSoaPermission = userPerm.includes(definedSoaPerm);
    setSoaPerm(hasSoaPermission);
    setHasAllPermissions(hasAllPerms);
    setIsHODOnly(isOnlyHOD);
  }, []);
  
  const CardData = [
    {
      title: "Appraisal Period",
      subtitle: "Create Appraisal period for each appraisee under supervision",
      link: "appraisal-period",
      icon: period,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "Objectives",
      subtitle:
        "Create performance objectives for each appraisee under supervision",
      link: "Manage-Objectives",
      icon: objectives,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "Key Result Area",
      subtitle:
        "Create key result area for each appraisee under supervision",
      link: "key-result-area",
      icon: reslt,
      permission: hasAllPermissions || isHODOnly || soaPerm,
    },
    {
      title: "Score Base Recommendation",
      subtitle:
        "Create score base recommendation for each appraisee under supervision",
      link: "Score-Base-recommendations",
      icon: score,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "Performance Status Labels",
      subtitle:
        "Create performance status labels for each appraisee under supervision",
      link: "performance-status-label",
      icon: performance,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "Counselling Type",
      subtitle:
        "Create counselling type for each appraisee under supervision",
      link: "Counselling-Type",
      icon: counsel,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "PIP",
      subtitle:
        "Create PIP for each appraisee under supervision",
      link: "performance-improvement-plan",
      icon: pip,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "Rating Scale",
      subtitle:
        "Create rating scale for each appraisee under supervision",
      link: "rating-scale",
      icon: rating,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "Commitee List",
      subtitle:
        "Create committee list for each appraisee under supervision",
      link: "Committee-List",
      icon: committee,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "Development Plan",
      subtitle:
        "Create development plan for each appraisee under supervision",
      link: "Development-Plan",
      icon: rating,
      permission: hasAllPermissions && !isHODOnly,
    },
    {
      title: "Expected Improvement Outcome",
      subtitle:
        "Create expected improvement outcome for each appraisee under supervision",
      link: "Expected-Improvement-Plan",
      icon: score,
      permission: hasAllPermissions && !isHODOnly,
    },
  ];

  const visibleCards = CardData.filter((card) => card.permission);

  return (
    <div className={Layout.Route_Layout}>
      <section className="grid grid-cols-3 gap-y-5">
        {visibleCards.map((data, index) => (
          <CardComp
            key={index}
            title={data.title}
            subtitle={data.subtitle}
            link={data.link}
            icon={data.icon}
          />
        ))}
      </section>

      {visibleCards.length === 0 && (
        <div className="text-center py-8">
          <p className="text-gray-500">
            You do not have permission to view any appraisal setup options.
          </p>
        </div>
      )}
    </div>
  );
};
